export const COLLAPSE_MENU = "COLLAPSE_MENU";
export const COLLAPSE_TOGGLE = "COLLAPSE_TOGGLE";
export const FULL_SCREEN = "FULL_SCREEN";
export const FULL_SCREEN_EXIT = "FULL_SCREEN_EXIT";
export const CHANGE_LAYOUT = "CHANGE_LAYOUT";
export const NAV_CONTENT_LEAVE = "NAV_CONTENT_LEAVE";
export const NAV_COLLAPSE_LEAVE = "NAV_COLLAPSE_LEAVE";
export const LOGIN_REQUESTED = "LOGIN_REQUESTED";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const UI_LOADING = "UI_LOADING";

export const EMPLOYEE_REQUESTED = "EMPLOYEE_REQUESTED";
export const EMPLOYEE_SUCCESS = "EMPLOYEE_SUCCESS";
export const EMPLOYEE_FAIL = "EMPLOYEE_FAIL";

export const EMPLOYEE_ONLINE_INFORMATION_REQUESTED =
  "EMPLOYEE_ONLINE_INFORMATION_REQUESTED";
export const EMPLOYEE_ONLINE_INFORMATION_SUCCESS =
  "EMPLOYEE_ONLINE_INFORMATION_SUCCESS";
export const EMPLOYEE_ONLINE_INFORMATION_FAIL =
  "EMPLOYEE_ONLINE_INFORMATION_FAIL";

export const EMPLOYEE_WORKER_REQUESTED = "EMPLOYEE_WORKER_REQUESTED";
export const EMPLOYEE_WORKER_SUCCESS = "EMPLOYEE_WORKER_SUCCESS";
export const EMPLOYEE_WORKER_FAIL = "EMPLOYEE_WORKER_FAIL";

export const EMPLOYEE_WORKER_UPDATED = "EMPLOYEE_WORKER_UPDATED";

export const EMPLOYEE_SELECTED = "EMPLOYEE_SELECTED";

export const EMPLOYEE_WORKER_UPDATED_REQUESTED =
  "EMPLOYEE_WORKER_UPDATED_REQUESTED";
export const EMPLOYEE_WORKER_UPDATED_SUCCESS =
  "EMPLOYEE_WORKER_UPDATED_SUCCESS";
export const EMPLOYEE_WORKER_UPDATED_FAIL = "EMPLOYEE_WORKER_UPDATED_FAIL";

export const PRODUCT_GET = "PRODUCT_GET";
export const PRODUCT_GET_SUCCESS = "PRODUCT_GET_SUCCESS";

export const CUSTOMER_GET = "CUSTOMER_GET";
export const CUSTOMER_GET_SUCCESS = "CUSTOMER_GET_SUCCESS";

export const REPORT_GET = "REPORT_GET";
export const REPORT_GET_SUCCESS = "REPORT_GET_SUCCESS";


export const COLLAPSE_MENU_OFF = "COLLAPSE_MENU_OFF";
export const IS_MOBILE_APP = "IS_MOBILE_APP";

export const CUSTOMER_REPORT_PORT = "CUSTOMER_REPORT_PORT";
export const CUSTOMER_REPORT_PORT_SUCCESS = "CUSTOMER_REPORT_PORT_SUCCESS";

export const CUSTOMER_STAFF_PORT = "CUSTOMER_STAFF_PORT";
export const CUSTOMER_STAFF_PORT_SUCCESS = "CUSTOMER_STAFF_PORT_SUCCESS";

export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
export const PRODUCT_REQUEST_SUCCESS = "PRODUCT_REQUEST_SUCCESS";

export const CUSTOMER_STAFF_CUSTOMER_SUCCESS = "CUSTOMER_STAFF_CUSTOMER_SUCCESS";
export const CUSTOMER_STAFF_CUSTOMER_POST = "CUSTOMER_STAFF_CUSTOMER_POST";

export const LOGIN_HISTORY_POST = "LOGIN_HISTORY_POST";
export const LOGIN_HISTORY_SUCCESS = "LOGIN_HISTORY_SUCCESS";
export const LOGIN_HISTORY_FAIL = "LOGIN_HISTORY_FAIL";

export const ACCECPT_NEW_DEVICE_POST = "ACCECPT_NEW_DEVICE_POST";
export const ACCECPT_NEW_DEVICE_SUCCESS = "ACCEPT_NEW_DEVICE_SUCCESS";
export const ACCECPT_NEW_DEVICE_FAIL = "ACCEPT_NEW_DEVICE_FAIL";

export const GET_FILE_FOLDER_TREE = "GET_FILE_FOLDER_TREE";
export const GET_FOLDER_TREE_SUCCESS = "GET_FOLDER_TREE_SUCCESS";

export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL";
export const GET_NOTIFICATION_DETAIL = "GET_NOTIFICATION_DETAIL";
export const GET_NOTIFICATION_DETAIL_SUCCESS =
  "GET_NOTIFICATION_DETAIL_SUCCESS";
export const GET_NOTIFICATION_DETAIL_FAIL = "GET_NOTIFICATION_DETAIL_FAIL";
export const POST_NOTIFICATION = "POST_NOTIFICATION";
export const POST_NOTIFICATION_SUCCESS = "POST_NOTIFICATION_SUCCESS";
export const POST_NOTIFICATION_FAIL = "POST_NOTIFICATION_FAIL";
export const GET_NOTIFICATION_READ = "GET_NOTIFICATION_READ";
export const GET_NOTIFICATION_READ_SUCCESS =
  "GET_NOTIFICATION_READ_SUCCESS";
export const GET_NOTIFICATION_READ_FAIL = "GET_NOTIFICATION_READ_FAIL";
export const GET_NOTIFICATION_DELETE = "GET_NOTIFICATION_DELETE";
export const GET_NOTIFICATION_DELETE_SUCCESS =
  "GET_NOTIFICATION_DELETE_SUCCESS";
export const GET_NOTIFICATION_DELETE_FAIL =
  "GET_NOTIFICATION_DELETE_FAIL";
export const GET_NOTIFICATION_DELETE_ALL = "GET_NOTIFICATION_DELETE_ALL";
export const GET_NOTIFICATION_DELETE_ALL_SUCCESS =
  "GET_NOTIFICATION_DELETE_ALL_SUCCESS";

export const POST_FILE_MANAGER_FOLDER = "POST_FILE_MANAGER_FOLDER";
export const POST_FILE_MANAGER_FOLDER_SUCCESS =
  "POST_FILE_MANAGER_FOLDER_SUCCESS";
export const POST_FILE_MANAGER_FOLDER_FAIL =
  "POST_FILE_MANAGER_FOLDER_FAIL";

export const POST_FILE_MANAGER_UPLOAD = "POST_FILE_MANAGER_UPLOAD";
export const POST_FILE_MANAGER_UPLOAD_SUCCESS =
  "POST_FILE_MANAGER_UPLOAD_SUCCESS";

export const POST_SETUP_LOGO = "POST_SETUP_LOGO";
export const POST_SETUP_LOGO_SUCCESS = "POST_SETUP_LOGO_SUCCESS";
export const GET_CONFIG_LOGO = "GET_CONFIG_LOGO";
export const GET_CONFIG_LOGO_SUCCESS = "GET_CONFIG_LOGO_SUCCESS";

export const GET_CHART_CONFIG_DATABASE = "GET_CHART_CONFIG_DATABASE";
export const GET_CHART_CONFIG_DATABASE_SUCCESS =
  "GET_CHART_CONFIG_DATABASE_SUCCESS";
export const POST_CHART_CONFIG_DATABASE = "POST_CHART_CONFIG_DATABASE";
export const POST_CHART_CONFIG_DATABASE_SUCCESS =
  "POST_CHART_CONFIG_DATABASE_SUCCESS";
export const PUT_CHART_CONFIG_DATABASE = "PUT_CHART_CONFIG_DATABASE";
export const PUT_CHART_CONFIG_DATABASE_SUCCESS =
  "PUT_CHART_CONFIG_DATABASE_SUCCESS";
export const DELETE_CHART_CONFIG_DATABASE = "DELETE_CHART_CONFIG_DATABASE";
export const DELETE_CHART_CONFIG_DATABASE_SUCCESS =
  "DELETE_CHART_CONFIG_DATABASE_SUCCESS";
export const GET_CHART_CONFIG_DATABASE_DETAIL = "GET_CHART_CONFIG_DATABASE_DETAIL";
export const GET_CHART_CONFIG_DATABASE_DETAIL_SUCCESS =
  "GET_CHART_CONFIG_DATABASE_DETAIL_SUCCESS";

export const GET_TEST_CONFIG_DATABASE = "GET_TEST_CONFIG_DATABASE";
export const GET_TEST_CONFIG_DATABASE_SUCCESS =
  "GET_TEST_CONFIG_DATABASE_SUCCESS";
export const GET_TEST_CONFIG_DATABASE_FAIL = "GET_TEST_CONFIG_DATABASE_FAIL";

export const POST_PERMISSION_ASSIGN = "POST_PERMISSION_ASSIGN";
export const POST_PERMISSION_ASSIGN_SUCCESS =
  "POST_PERMISSION_ASSIGN_SUCCESS";
export const POST_PERMISSION_ASSIGN_FAIL = "POST_PERMISSION_ASSIGN_FAIL";
export const GET_PERMISSION_ASSIGN = "GET_PERMISSION_ASSIGN";
export const GET_PERMISSION_ASSIGN_SUCCESS =
  "GET_PERMISSION_ASSIGN_SUCCESS";
export const GET_PERMISSION_ASSIGN_FAIL = "GET_PERMISSION_ASSIGN_FAIL";

export const GET_CUSTOMER_GROUP = "GET_CUSTOMER_GROUP";
export const GET_CUSTOMER_GROUP_SUCCESS = "GET_CUSTOMER_GROUP_SUCCESS";
export const GET_CUSTOMER_GROUP_FAIL = "GET_CUSTOMER_GROUP_FAIL";

export const GET_PRODUCT_CATEGORY = "GET_PRODUCT_CATEGORY";
export const GET_PRODUCT_CATEGORY_SUCCESS =
  "GET_PRODUCT_CATEGORY_SUCCESS";
export const GET_PRODUCT_CATEGORY_FAIL = "GET_PRODUCT_CATEGORY_FAIL";

export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const GET_ORGANIZATION_SUCCESS = "GET_ORGANIZATION_SUCCESS";
export const GET_ORGANIZATION_FAIL = "GET_ORGANIZATION_FAIL";

export const PUT_SET_DATABASE_DEFAULT = "PUT_SET_DATABASE_DEFAULT";
export const PUT_SET_DATABASE_DEFAULT_SUCCESS =
  "PUT_SET_DATABASE_DEFAULT_SUCCESS";
export const PUT_SET_DATABASE_DEFAULT_FAIL =
  "PUT_SET_DATABASE_DEFAULT_FAIL";

export const GET_WORKER_INFO = "GET_WORKER_INFO";
export const GET_WORKER_INFO_SUCCESS = "GET_WORKER_INFO_SUCCESS";
export const GET_WORKER_INFO_FAIL = "GET_WORKER_INFO_FAIL";

export const PUT_WORKER_INFO = "PUT_WORKER_INFO";
export const PUT_WORKER_INFO_SUCCESS = "PUT_WORKER_INFO_SUCCESS";
export const PUT_WORKER_INFO_FAIL = "PUT_WORKER_INFO_FAIL";

export const UPDATE_KPI = "UPDATE_KPI";
export const UPDATE_PRODUCT_POSITION = "UPDATE_PRODUCT_POSITION";
export const UPDATE_PRODUCT_POSITION_SUCCESS = "UPDATE_PRODUCT_POSITION_SUCCESS";
export const UPDATE_PRODUCT_POSITION_FAIL = "UPDATE_PRODUCT_POSITION_FAIL";
